import * as React from 'react';

export const TodayDeliveryWordingIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    width='55'
    height='32'
    viewBox='0 0 6574 4163'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <g id='Logo_Today_Delivery'>
      <g id='Item_Color'>
        <path
          id='Vector 2'
          d='M1641.37 1926.25L2085.67 745.186C2532.17 893.727 2984.73 1421.96 2867.82 2095.51C2720.06 2946.72 1987.62 3152.2 1641.37 3150.03L1641.37 1926.25Z'
          fill='url(#paint0_linear_4_108)'
        />
        <g id='Group'>
          <path
            id='Vector'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M2387.6 2192.19L2272.26 2760.06H2421.63L2536.97 2192.19H2739.29L2765.77 2063.4H2202.29L2175.82 2192.19H2387.6Z'
            fill='var(--primary-color)'
          />
        </g>
        <g id='Group_2'>
          <path
            id='Vector_2'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M2737.4 2468.34C2737.4 2567.87 2763.4 2643.96 2815.4 2696.66C2867.4 2749.35 2941.29 2775.69 3037.11 2775.69C3096.34 2775.69 3148.83 2764.14 3194.52 2741.06C3240.22 2717.96 3278.66 2686.57 3309.86 2646.9C3341.06 2607.21 3364.84 2561.36 3381.22 2509.32C3397.63 2457.28 3405.82 2402.65 3405.82 2345.41C3405.82 2296.61 3398.73 2253.67 3384.54 2216.59C3370.37 2179.51 3350.35 2148.29 3324.51 2122.92C3298.68 2097.56 3267.15 2078.54 3229.97 2065.84C3192.77 2053.17 3151.49 2046.83 3106.12 2046.83C3049.39 2046.83 2998.18 2058.19 2952.49 2080.97C2906.79 2103.74 2868.03 2134.48 2836.2 2173.19C2804.36 2211.88 2779.95 2256.61 2762.93 2307.35C2745.91 2358.08 2737.4 2411.75 2737.4 2468.34ZM2885.84 2468.34C2885.84 2435.16 2890.25 2401.18 2899.07 2366.39C2907.89 2331.57 2921.29 2300.02 2939.26 2271.74C2957.2 2243.43 2980.21 2220.33 3008.27 2202.45C3036.32 2184.55 3069.25 2175.62 3107.05 2175.62C3134.8 2175.62 3158.12 2180.49 3177.02 2190.25C3195.92 2200 3211.37 2213.02 3223.35 2229.29C3235.32 2245.55 3244 2264.57 3249.34 2286.37C3254.71 2308.16 3257.37 2331.41 3257.37 2356.12C3257.37 2389.3 3252.82 2423.14 3243.67 2457.6C3234.55 2492.07 3220.83 2523.46 3202.55 2551.76C3184.28 2580.07 3161.57 2603.15 3134.48 2621.05C3107.38 2638.92 3075.55 2647.88 3039 2647.88C3011.88 2647.88 2988.73 2643.01 2969.5 2633.23C2950.27 2623.47 2934.52 2610.31 2922.24 2593.72C2909.94 2577.13 2900.8 2558.11 2894.82 2536.64C2888.82 2515.17 2885.84 2492.4 2885.84 2468.34Z'
            fill='var(--primary-color)'
          />
        </g>
        <g id='Group_3'>
          <path
            id='Vector_3'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M3609.07 2631.27L3699.83 2192.18H3811.38C3837.85 2192.18 3860.39 2196.25 3878.99 2204.39C3897.57 2212.51 3912.86 2224.06 3924.83 2239.02C3936.82 2253.98 3945.48 2271.71 3950.85 2292.2C3956.2 2312.69 3958.88 2335.63 3958.88 2361C3958.88 2398.08 3953.67 2432.87 3943.27 2465.4C3932.88 2497.91 3917.76 2526.54 3897.9 2551.25C3878.04 2575.99 3853.46 2595.5 3824.15 2609.8C3794.84 2624.11 3761.28 2631.27 3723.47 2631.27H3609.07ZM3576.93 2063.4L3435.11 2760.06H3716.84C3781.77 2760.06 3838.64 2749.32 3887.49 2727.86C3936.33 2706.41 3976.99 2676.63 4009.45 2638.6C4041.91 2600.54 4066.35 2555.5 4082.73 2503.44C4099.12 2451.4 4107.31 2395.14 4107.31 2334.65C4107.31 2248.12 4083.36 2181.29 4035.45 2134.13C3987.56 2086.96 3916.01 2063.4 3820.84 2063.4H3576.93Z'
            fill='var(--primary-color)'
          />
        </g>
        <g id='Group_4'>
          <path
            id='Vector_4'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M4464.68 2063.4L4066.65 2760.08H4222.64L4307.73 2604.92H4560.17L4581.9 2760.08H4729.4L4616.89 2063.4H4464.68ZM4366.36 2490.76C4366.36 2490.76 4487.36 2259.83 4511.96 2213.65C4512.24 2213.09 4513.85 2213.65 4513.85 2213.65L4546.94 2490.76H4366.36Z'
            fill='var(--primary-color)'
          />
        </g>
        <g id='Group_5'>
          <path
            id='Vector_5'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M4935.51 2489.79L4881.63 2760.06H5030.99L5083.01 2496.62L5412 2063.4H5237.11L5027.23 2360.02L4926.06 2063.4H4773.85L4935.51 2489.79Z'
            fill='var(--primary-color)'
          />
        </g>
      </g>

      <g id='Item_Black' fill='black'>
        <g id='Group_6'>
          <g id='Group_7'>
            <path d='M2828.07 3219.9V2978.38H2888.18C2908.95 2978.38 2926.39 2981.34 2940.53 2987.22C2954.66 2993.14 2966.03 3001.63 2974.6 3012.73C2983.2 3023.83 2989.39 3037.16 2993.14 3052.72C2996.88 3068.27 2998.76 3085.71 2998.76 3105.05C2998.76 3126.15 2996.08 3144.04 2990.71 3158.72C2985.35 3173.38 2978.19 3185.28 2969.24 3194.4C2960.29 3203.54 2950.1 3210.06 2938.65 3213.99C2927.2 3217.95 2915.39 3219.9 2903.22 3219.9H2828.07ZM2743.81 2907.52V3290.76H2909.13C2938.47 3290.76 2963.98 3285.82 2985.63 3276C3007.28 3266.15 3025.34 3252.65 3039.82 3235.46C3054.33 3218.3 3065.16 3197.91 3072.3 3174.28C3079.46 3150.65 3083.05 3124.9 3083.05 3096.99C3083.05 3065.14 3078.66 3037.41 3069.89 3013.81C3061.12 2990.18 3048.95 2970.51 3033.39 2954.75C3017.83 2939.02 2999.38 2927.22 2978.11 2919.32C2956.81 2911.46 2933.81 2907.52 2909.13 2907.52H2743.81Z' />
          </g>
          <g id='Group_8'>
            <path d='M3141.53 2907.55V3290.78H3432.46V3219.93H3225.79V3126H3411.51V3060.51H3225.79V2978.4H3428.18V2907.55H3141.53Z' />
          </g>
          <g id='Group_9'>
            <path d='M3489.37 2907.55V3290.78H3760.43V3219.93H3573.63V2907.55H3489.37Z' />
          </g>
          <g id='Group_10'>
            <path d='M3891.96 2907.55H3807.68V3290.78H3891.96V2907.55Z' />
          </g>
          <g id='Group_11'>
            <path d='M4144.25 3290.76L4271.46 2907.52H4184.51L4098.09 3176.96H4097.01L4011.67 2907.52H3925.25L4049.23 3290.76H4144.25Z' />
          </g>
          <g id='Group_12'>
            <path d='M4304.21 2907.55V3290.78H4595.14V3219.93H4388.47V3126H4574.22V3060.51H4388.47V2978.4H4590.85V2907.55H4304.21Z' />
          </g>
          <g id='Group_13'>
            <path d='M4736.31 3080.9V2973.02H4828.64C4847.96 2973.02 4862.44 2977.23 4872.11 2985.64C4881.79 2994.04 4886.6 3007.54 4886.6 3026.16C4886.6 3045.47 4881.79 3059.43 4872.11 3068.02C4862.44 3076.62 4847.96 3080.9 4828.64 3080.9H4736.31ZM4652.04 2907.55V3290.76H4736.31V3141.01H4820.57C4841.7 3141.01 4856.9 3145.67 4866.2 3154.96C4875.52 3164.28 4881.59 3178.94 4884.47 3198.98C4886.6 3214.37 4888.23 3230.48 4889.28 3247.29C4890.36 3264.1 4893.24 3278.61 4897.87 3290.76H4982.16C4978.2 3285.4 4975.27 3278.86 4973.29 3271.17C4971.34 3263.47 4969.89 3255.33 4969.01 3246.76C4968.11 3238.17 4969.89 3255.33 4969.01 3246.76C4968.11 3238.17 4967.48 3229.75 4967.13 3221.53C4966.75 3213.29 4966.4 3206.15 4966.05 3200.06C4965.32 3190.39 4964 3180.74 4962.02 3171.07C4960.06 3161.4 4956.93 3152.56 4952.62 3144.49C4948.34 3136.45 4942.8 3129.48 4935.98 3123.57C4929.19 3117.66 4920.6 3113.3 4910.23 3110.42V3109.34C4931.7 3100.77 4947.18 3088.24 4956.66 3071.78C4966.13 3055.32 4970.89 3035.83 4970.89 3013.28C4970.89 2998.6 4968.28 2984.92 4963.09 2972.22C4957.91 2959.51 4950.39 2948.34 4940.54 2938.67C4930.72 2929 4918.89 2921.41 4905.11 2915.84C4891.36 2910.31 4875.87 2907.55 4858.68 2907.55H4652.04Z' />
          </g>
          <g id='Group_14'>
            <path d='M5119.02 3141.56V3290.78H5203.29V3143.71L5345.53 2907.55H5251.6L5162.49 3058.9L5072.87 2907.55H4978.38L5119.02 3141.56Z' />
          </g>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M2346.67 2930.75C2390.15 2901.19 2434.46 2922.2 2464.02 2965.68C2493.58 3009.15 2497.25 3058.76 2453.77 3088.31C2225.02 3243.77 1948.91 3334.69 1651.74 3334.69C863.006 3334.69 222.655 2694.39 222.655 1905.73C222.655 1117.06 863.006 476.759 1651.74 476.759C2440.47 476.759 3080.82 1117.06 3080.82 1905.73C3080.82 1958.29 3036.38 1988.37 2983.78 1988.37C2931.22 1988.37 2890.28 1958.29 2890.28 1905.73C2890.28 1222.2 2335.32 667.266 1651.74 667.266C968.158 667.266 413.179 1222.2 413.179 1905.73C413.179 2589.24 968.158 3144.17 1651.74 3144.17C1909.23 3144.17 2148.47 3065.46 2346.67 2930.75Z'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M1277.59 436.959C1198.72 436.959 1134.69 372.937 1134.69 294.079C1134.69 215.22 1198.72 151.198 1277.59 151.198H1998.4C2077.27 151.198 2141.3 215.22 2141.3 294.079C2141.3 372.937 2077.27 436.959 1998.4 436.959H1277.59Z'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M2561.11 718.77C2516.73 670.299 2520.06 594.921 2568.54 550.548C2617 506.172 2692.4 509.497 2736.76 557.967L3132.4 990.071C3176.76 1038.54 3173.44 1113.92 3124.97 1158.29C3076.48 1202.67 3001.11 1199.34 2956.72 1150.87L2561.11 718.77Z'
          />
        </g>
        <path
          d='M1651.61 2654.13L1651.61 1852.19'
          stroke='black'
          strokeWidth='108.33'
          strokeMiterlimit='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M1654.49 1845.13L1858.91 1349.05'
          stroke='black'
          strokeWidth='108.33'
          strokeMiterlimit='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <circle cx='1651.05' cy='1864.85' r='104.88' fill='black' />
      </g>
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_4_108'
        x1='1681.3'
        y1='3150.53'
        x2='2554.74'
        y2='1037.66'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0.380509'
          stopColor='var(--primary-color)'
          stopOpacity='0.2'
        />
        <stop offset='1' stopColor='var(--primary-color)' />
      </linearGradient>
    </defs>
  </svg>
);
